import axios from "axios";
import LocalStorageKeys from "../../enums/local-storage-keys";
import { ClientPortalLoginModel } from "../../models/client-portal-login-model";

export const sessionOrLocalStorageUserData = (): string | null =>
  localStorage.getItem(LocalStorageKeys.USER);

export const getClientPortalUserToken = (): string =>
  JSON.parse(sessionOrLocalStorageUserData() as string)?.token;

export async function clientPortalLogin(credentials: {
  username: string;
  password: string;
  isClientPortalUser: boolean;
}): Promise<ClientPortalLoginModel | null> {
  try {
    const response = await axios.post<ClientPortalLoginModel>("/api/login", credentials);
    return response.data;
  } catch (error) {
    return error;
  }
}
